export const MENU_CHANGE = "MENU_CHANGE";
export const LANGUAGE_CHANGE = "LANGUAGE_CHANGE";
export const SIGN_IN = "SIGN_IN";
export const HOST_URL = "http://localhost:8076";
export const SHORT_HOST_URL = "http://localhost:8076/services/shortservice";
export const USER_HOST_URL = "http://localhost:8076/services/userservice";
export const back = "";
export const ADMIN_MENU_CHANGE = "ADMIN_MENU_CHANGE";
